<template>
  <div class="cmp-bonus-list">
    <span v-for="(bonus, index) in bonuses" :key="index" class="bonus">
      <span class="text-positive">{{
        $t(bonus.property, {
          value: bonusValue(bonus),
        })
      }}</span><span v-if="info || bonus.bonusHint">
        <ws-icon :name="Icon.INFO" class="info-icon" />
        <ws-tooltip :delay="500">{{ info || $t(bonus.bonusHint) }}</ws-tooltip>
      </span>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { WsIcon, WsTooltip } from '@odin/components-vue2';
import { Icon } from '@odin/assets';

@Component({
  components: {
    WsIcon,
    WsTooltip,
  },
})
export class BonusList extends Vue {
  @Prop()
  readonly bonuses!: any[];
  @Prop()
  readonly info!: string;

  Icon = Icon;

  bonusValue(bonus: any) {
    if (bonus.property === 'bonus.property.price' && !bonus.percentage) {
      return this.$n(bonus.value, 'currency');
    }
    return bonus.value + (bonus.percentage ? '%' : '');
  }
}
export default BonusList;
</script>

<style lang="scss" scoped>
.cmp-bonus-list {
  > .bonus + .bonus {
    &:before {
      content: ', ';
    }
  }
}
</style>
